import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

export const Footer = ({ showModal }) => {
  return (
    <div
      id="footer"
      style={{
        color:'white',
        display:'flex',
        justifyContent:'center',
        flexDirection: 'column',
        position: 'fixed',
        bottom:'0',
        width:'100%',
        fontSize:'1.2em'
      }}
    >
      <div style={{display:'flex', justifyContent:'center'}}>Copyright © 2020 - {new Date().getFullYear()} Visceral Sounds</div>
        <div className="row notice" style={{ height:'4rem', fontSize: '2.5vh', width: "100%", color: 'black', backgroundColor: '#D39D60'}}>
          <div style={{display:'flex', justifyContent:'center', flexDirection: 'column', height: '100%', width: '100%'}}>
            <div style={{display:'flex', justifyContent:'center'}}>
              <NavLink
                to="/news"
                onClick={showModal.bind(this, 'news','news')}
                style={{color: 'black', textDecoration: 'underline'}}>
                  Neural Patches is now Visceral Sounds!
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    );
}

Footer.propTypes = {
  showModal: PropTypes.func.isRequired
}
